import type { TextProps } from "@uhg-harmony/react";
export { Text, type TextProps } from "@uhg-harmony/react";

export const textDefaults: TextProps = {
  weight: "regular",
  className: "",
  inverse: false,
  italic: false,
};
